import React, { useEffect, useState } from 'react';
import { Toast } from 'primereact/toast';
import { useLocation, useNavigate } from 'react-router-dom';
import { Button } from '@mui/material';
import { CForm, CFormInput, CFormLabel, CRow } from '@coreui/react';
import { useAuth } from '../contexts/AuthContext';
import CInput from '../components/CInput';

function Login() {
    const { auth, login, toast } = useAuth();

    const [validated, setValidated] = useState(false);
    const [credential, setCredential] = useState({
        email: "",
        password: ""
    });
    const navigate = useNavigate();
    const location = useLocation();

    const handleSubmit = async (e) => {
        e.preventDefault();

        const form = e.currentTarget;
        setValidated(true);

        if (form.checkValidity() === false) {
            e.stopPropagation();
            const firstInvalidInput = form.querySelector(':invalid');
            if (firstInvalidInput) {
                firstInvalidInput.focus();
                firstInvalidInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        } else {
            try {
                await login(credential);
            } catch (error) {
                console.log(error);
            }
        }
    };

    useEffect(() => {
        if (auth?.token) {
            location.pathname !== '/' ? navigate(location.pathname) : (auth.user.role === "admin" && navigate('/admin/dashboard/view'));
        }
    }, [auth?.token, navigate]);

    return (
        <>
            <Toast ref={toast} />
            <div className="vh-100 login-page">
                <div className="login-left-container">
                    <img src='/images/a.jpg' className="img-fluid w-100 h-100" alt="Logo" />
                </div>
                <div className="d-flex flex-column justify-content-center align-items-center mx-auto login-right-container">
                    <CForm onSubmit={handleSubmit} noValidate validated={validated}>
                        <div className="text-center mb-5">
                            <p className="credential-title">Login</p>
                        </div>
                        <CRow className="mb-4">
                            <CInput
                                label={'Email'}
                                type={'email'}
                                value={credential.email}
                                onChange={(value) => setCredential({ ...credential, email: value })}
                                required={true}
                                errorMessage='Email is required.'
                            />
                        </CRow>
                        <CRow className="mb-4">
                            <div>
                                <div>
                                    <CFormLabel>Password <span className="text-danger">*</span></CFormLabel>
                                </div>
                                <div className='w-100'>
                                    <CFormInput
                                        type='password'
                                        minlength="8"
                                        value={credential.password}
                                        onChange={(e) => setCredential({ ...credential, password: e.target.value })}
                                        required
                                        feedbackInvalid='Please enter a password with 8 or more characters.'
                                    />
                                </div>
                            </div>
                        </CRow>
                        <div>
                            <Button fullWidth variant="contained" color='primary' type="submit">
                                Submit
                            </Button>
                        </div>
                    </CForm>
                </div>
            </div>
        </>
    );
}

export default Login;
